﻿import "ng-infinite-scroll";
import "angulartics";
import "angulartics-google-analytics";
import "angulartics-scroll";

// Run this as an import so it goes BEFORE the subsequent calls
import "./fliptoWeb"

import "../../scripts/src/constants/_call-times.ts";
import "../../scripts/src/constants/_configuration.ts";
import "../../scripts/src/constants/_events.ts";
import "../../scripts/src/constants/_time-zones.ts";

import "../../scripts/src/_router.ts";

import "../../components/layout/head/head.controller.ts";
import "../../components/about/team-member.directive.ts";
import "../../components/blog/blog-article.controller.ts";
import "../../components/blog/blog.controller.ts";
import "../../components/contact-forms/contact/contact.controller.ts";
import "../../components/contact-forms/get-started/get-started.controller.ts";
import "../../components/contact-forms/get-started/get-started.directive.ts";
import "../../components/contact-forms/partner-signup/partner-signup.controller.ts";
import "../../components/contact-forms/partner-portal-signup/partner-portal-signup.controller.ts";
import "../../components/features/carousel/carousel-features.directive.ts";
import "../../components/features/going-live/going-live.controller.ts";
import "../../components/features/management/management.controller.ts";
import "../../components/features/photo-advocacy/photo-advocacy.controller.ts";
import "../../components/features/post-stay-advocacy/poststay.controller.ts";
import "../../components/features/pre-stay-advocacy/prestay.controller.ts";
import "../../components/features/superchargers/superchargers.controller.ts";
import "../../components/features/features.controller.ts";
import "../../components/intro/positional-class.ts";
import "../../components/layout/navigation/navigation.controller.ts";
import "../../components/error-pages/404/404.controller.ts";
import "../../components/intro/contacts.constant.ts";
import "../../components/intro/representatives.service.ts";
import "../../components/intro/intro.controller.ts";
import "../../components/intro/introPersonalized.controller.ts";
import "../../components/content/webisode/fuel-reimagined-marketing/webisodeFuel.controller.ts";

import "../../scripts/src/animations/_carousels.ts";
import "../../scripts/src/animations/_modal.ts";
import "../../scripts/src/animations/_navigation.ts";
import "../../scripts/src/animations/_view.ts";

import "../../scripts/src/directives/loadingAnimation.ts";
import "../../scripts/src/directives/spinner.ts";
import "../../scripts/src/directives/squashingMenu.ts";
import "../../scripts/src/directives/hoverClass.ts";
import "../../scripts/src/directives/hoverPanels.ts";
import "../../scripts/src/directives/canvasSlides.ts";
import "../../scripts/src/directives/sections.ts";
import "../../scripts/src/directives/carouselCards.ts";

import "../../scripts/src/services/_api-service.ts";
import "../../scripts/src/services/api-service-news.ts";
import "../../scripts/src/services/_server.ts";
import "../../scripts/src/services/copyToClipboard.ts";
import "../../scripts/src/services/userAgent.ts";
import { fliptoWeb } from "./fliptoWeb.js";

fliptoWeb
    .constant("angularMomentConfig", {
        preprocess: "utc"
    })
    .filter("unsafe", ($sce) => { return $sce.trustAsHtml; })
    .run(["$rootScope", "$templateCache", ($rootScope, $templateCache) => {
        $rootScope.$on("$routeChangeStart", () => {
            $templateCache.removeAll();
        });
    }])
    .run([
        "$window", "config", "$rootScope", "$timeout", "$interval", ($window, config, $rootScope, $timeout, $interval) => {
            if (config.isDebugMode)
                console.log("Application Running");

            /*
                * handle fouc
                */
            $rootScope.$on("$viewContentLoaded", () => {
                var foucEls = angular.element(document.querySelectorAll(".handle-fouc"));
                for (var i = 0, l = foucEls.length; i < l; i++) {
                    var el = foucEls[i],
                        className = "handle-fouc";
                    if (el.classList)
                        el.classList
                            .remove(className);
                    else
                        el.className = el.className.replace(new RegExp(`(^|\b)${className.split(" ").join("|")}(\b|$)`, "gi"), " ");
                }
            });


            /*
                * Page Titles
                */
            $rootScope.page_title = "Flip.to";
            $rootScope.$on("$routeChangeSuccess", (e, current, pre) => {
                $rootScope.page_title = current.$$route.title;
            });

            $rootScope.$on("$stateChangeSuccess", (e, current, pre) => {
                $rootScope.isLoaded = true;
            });

            let beforeModalOffset;
            $rootScope.$on("modal.show.before", (e) => {
                beforeModalOffset = window.pageYOffset;
            });

            $rootScope.$on("modal.hide", (e) => {
                setTimeout(function () { window.scrollTo(0, beforeModalOffset); });
            });

            $rootScope.$on("$viewContentLoaded", (e, view) => {
                $timeout(function () {
                    window["dataLayer"].push({ 'event': 'optimize.activate' });
                }, 0, false);
            });


            /*
                * Code for handling the animated hamburger menu
                */
            //var anchor = document.querySelectorAll('button.lines-button');

            //[].forEach.call(anchor, function (anchor) {
            //    var open = false;
            //    anchor.onclick = function (event) {
            //        event.preventDefault();
            //        if (!open) {
            //            this.classList.add('close');
            //            open = true;
            //        }
            //        else {
            //            this.classList.remove('close');
            //            open = false;
            //        }
            //    }
            //});

        }
    ])
    .config(["$httpProvider", ($httpProvider) => {
        var ANGULAR_REQUEST_HEADER = "FROM-ANGULAR";
        $httpProvider.defaults.headers.common[ANGULAR_REQUEST_HEADER] = "true";

        var requestInterceptor = [
            "$q",
            ($q) => {
                var interceptorInstance = {
                    request: (config) => {
                        config.headers[ANGULAR_REQUEST_HEADER] = true;
                        return config || $q.when(config);
                    }
                };
                return interceptorInstance;
            }
        ];

        $httpProvider.interceptors.push(requestInterceptor);
    }])
    .config(["$modalProvider", ($modalProvider) => {
        angular.extend($modalProvider.defaults, {
            backdrop: 'static',
            container: 'body'
        });
    }]);

if (window["isPartner"]) {
    fliptoWeb.service("PartnerService",
        [
            function() {

                class PartnerService {

                    private name: string;

                    setName(name: string) {
                        this.name = name;
                    }

                    getName() {
                        return this.name;
                    }

                }

                return new PartnerService();
            }
        ]);
}
